import initialState from './initialState';

let reducers = {
  FILE_SUBMISSION_SUCCESS : (state, payload) => {
    return [...state,  Object.assign({}, payload)];
  }
};

export default function fileSubmission(state = initialState.fileSubmission, action) {
  let reducer = reducers[action.type];
  return (reducer ? reducer(state, action.fileSubmission): state);
}



/** WEBPACK FOOTER **
 ** ./src/reducers/fileSubmission.js
 **/